import { useRef, useState } from 'react';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

/**
 * The onboarding form link for an account still in Application Pending. The endpoint is scoped to
 * the partner that owns the account, so the caller passes that partner's bearer.
 */
export default function useFetchOnboardingAppUrl() {
  const [fetching, setFetching] = useState(false);
  const [onboardingUrl, setOnboardingUrl] = useState<string>();
  // The account whose link is wanted now. A response that arrives after the caller moved to another
  // account is dropped rather than published — a stale link here is one a user could copy or email.
  const requestedAccountId = useRef<string | undefined>(undefined);

  async function fetchOnboardingAppUrl(accountId: string, bearer: string) {
    try {
      setFetching(true);
      requestedAccountId.current = accountId;

      const res = await api.fetchOnboardingAppUrl({ VopayAccountID: accountId }, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      if (requestedAccountId.current !== accountId) return res.OnboardingURL;

      setOnboardingUrl(res.OnboardingURL);

      return res.OnboardingURL;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  function reset() {
    requestedAccountId.current = undefined;
    setOnboardingUrl(undefined);
  }

  return { onboardingUrl, fetching, fetchOnboardingAppUrl, reset };
}
